const LOG_PREFIX = "[OCM][Custom] "
const Instream = require('../../services/instream')
let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    utils.contentLoaded().then(() => {
      runOutstream(utils)
    })

    resolve(true)
  });
};

let runOutstream = (utils) => {
  if (utils.config.debug) {
    console.log(LOG_PREFIX + 'Running outstream')
  }

  (function (w, d, s) {
    try {
      d = w.top.document || d;
      w = w.top.document ? w.top : w;
    } catch (e) {
    }

    if (w.teads !== undefined) {
      return;
    }

    let exclude_urls = [
      //{'url': '2935139'}
    ]

    for (var z = 0; z < exclude_urls.length; z++) {
      if (w.location.href.indexOf(exclude_urls[z].url) > -1) {
        return;
      }
    }

    var selector;
    
    if (!utils.isMobile()) {
    	selector = document.querySelectorAll(".ocm_desktop > div > div,.ocm_desktop p, .ocm_desktop [dir='auto'], .ocm_desktop [data-editor='4cpmv']")[2];
    }
    else {
      	selector = document.querySelectorAll(".ocm_mobile > div > div,.ocm_mobile p, .ocm_mobile [dir='auto'], .ocm_mobile [data-editor='4cpmv']")[2];
    }
    
    if (!selector) {
      return
    }

    var ttag = function () {
      w.teads.page(145260).placement(159207, {
        slider: {allow_corner_position: false, allow_top_position: false},
        "css": "width:100% !important; height:auto !important; margin: 0px auto 26px",
        "format": "inread",
        "slot": {"insertAfter": true, "btf": false, "selector": selector, "minimum": 0}
      }).passback(function () {
       		 window.top.OCM.oipb = () => {
            	 ocmPassback(utils, selector)
          	}
          
            utils.config.services.instream.active = true
            const is = new Instream(utils, utils.config)
            is.run()
       
      }).serve();
    };
    if (w.teads && w.teads.page) {
      ttag();
    } else if (!w.teadsscript) {
      var protocol = w.location.protocol.match(/^https?:$/) ? w.location.protocol : 'https:';
      s.src = protocol + '//a.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true;
      s.onload = ttag;
      w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    }
  })(window, document, document.createElement('script'));
}

let ocmPassback = (utils, selector) => {
  if (!selector) {
    return
  }
  
  window.googletag.cmd.push(() => {
    let inread = googletag.sizeMapping()
    .addSize([0,0], [[1,1], [300,250]])
    .addSize([360,0], [[1, 1], [300,250],[336,280]])
	.build()
    
    googletag.defineSlot('/75351959,31156878/cyclades24.gr/inread_pb', [[1, 1], [300, 250], [336, 280]], 'ocm-outstream').defineSizeMapping(inread).addService(googletag.pubads());
    
    selector.insertAdjacentHTML('afterend', `<div id="ocm-outstream" style="margin-bottom: 26px;"></div>`)
    let div = document.getElementById('ocm-outstream')
    let script = document.createElement('script')
    script.text = `googletag.cmd.push(() => { googletag.display('ocm-outstream'); })`
    div.append(script)
  })
}

module.exports = customCode;